import { ServiceFetch } from '../service-fetch'

export default class PointCustomerModel extends ServiceFetch {
    getPointCustomerBy = (data) => this.authFetch({
        url: 'point-customer/getPointCustomerBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertPointCustomer = (data) => this.authFetch({
        url: 'point-customer/insertPointCustomer',
        method: 'POST',
        body: JSON.stringify(data),
    })

    deletePointCustomerByCode = (data) => this.authFetch({
        url: 'point-customer/deletePointCustomerByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
